import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["shouldShow"];
import { createSelector } from 'reselect';
import { memoize } from 'underscore';
import { createGenericOptionsSelector } from 'ContentData/helpers/reduxHelpers';
import { getWorkflowHybridPermissions, getFollowupEmailAction } from 'ContentData/helpers/workflowsHelpers';
import { getFormWorkflowDependencies } from 'ContentData/selectors/forms';
import { SUCCEEDED, FAILED } from 'ContentUtils/constants/RequestStatus';
export const getWorkflow = (state, props) => state.resources.workflows.workflows[props.id];
export const getWorkflows = state => state.resources.workflows.workflows;
export const getWorkflowsOptions = createGenericOptionsSelector(getWorkflows);
export const getWorkflowFetchStatus = (state, props) => state.resources.workflows.requestStatus[props.id];
export const getWorkflowHybrids = state => state.resources.workflows.hybrids;
export const getWorkflowHybridsRequestStatus = state => state.resources.workflows.hybridsRequestStatus;
export const getWorkflowHybrid = (state, props) => {
  return getWorkflowHybrids(state)[props.id];
};
export const getWorkflowSummaries = state => state.resources.workflows.summaries;
export const getAllWorkflowHybridsHaveLoaded = createSelector([getFormWorkflowDependencies, getWorkflowHybridsRequestStatus], (formWorkflowDependencies, workflowHybridsRequestStatus) => {
  if (!formWorkflowDependencies) return false;
  return formWorkflowDependencies.every(flowId => {
    const requestStatus = workflowHybridsRequestStatus[flowId];
    return requestStatus === SUCCEEDED || requestStatus === FAILED;
  });
});
const getFormGuid = (state, props) => props.formGuid;
const getContentId = (state, props) => props.contentId;
const memoizedGetFilteredHydratedFormWorkflowDependencies = memoize((formWorkflowDependencies, workflowHybrids, formGuid, contentId) => {
  const workflows = [];
  if (formWorkflowDependencies && formWorkflowDependencies.length) {
    formWorkflowDependencies.forEach(flowId => {
      const workflowHybrid = workflowHybrids[flowId];
      const workflowHybridPermissions = workflowHybrid && getWorkflowHybridPermissions(workflowHybrid, formGuid, contentId);
      const _ref = workflowHybridPermissions || {},
        {
          shouldShow
        } = _ref,
        permissions = _objectWithoutPropertiesLoose(_ref, _excluded);
      const hybridWithPermissions = Object.assign({}, workflowHybrid, permissions);
      if (shouldShow) {
        workflows.push(hybridWithPermissions);
      }
    });
  }
  return workflows;
}, (formWorkflowDependencies, workflowHybrids, formGuid, contentId) => {
  return `
      ${formWorkflowDependencies && formWorkflowDependencies.join('.')}-
      ${JSON.stringify(workflowHybrids)}-
      ${formGuid}-${contentId}
      `;
});
export const getFilteredHydratedFormWorkflowDependencies = createSelector([getFormWorkflowDependencies, getWorkflowHybrids, getFormGuid, getContentId], memoizedGetFilteredHydratedFormWorkflowDependencies);
export const getWorkflowsThatSendEmails = createSelector([getFilteredHydratedFormWorkflowDependencies], formWorkflowDependencies => {
  return formWorkflowDependencies.filter(workflowHybrid => {
    if (workflowHybrid.isEnabled) {
      const emailAction = getFollowupEmailAction(workflowHybrid);
      if (emailAction) {
        const {
          contentId: emailId
        } = emailAction.metadata || {};
        return emailId;
      }
    }
    return false;
  });
});
const memoizedGetFormWorkflowDependenciesMap = memoize(filteredHydratedFormWorkflowDependencies => {
  return filteredHydratedFormWorkflowDependencies.reduce((acc, flow) => {
    return Object.assign({}, acc, {
      [flow.flowId]: flow
    });
  }, {});
}, filteredHydratedFormWorkflowDependencies => {
  return filteredHydratedFormWorkflowDependencies.map(flow => flow.flowId).join('.');
});
const getFormWorkflowDependenciesMap = createSelector([getFilteredHydratedFormWorkflowDependencies], memoizedGetFormWorkflowDependenciesMap);
export const getWorkflowSummariesOptions = createSelector([getFormWorkflowDependenciesMap, getWorkflowSummaries], (formWorkflowDependenciesMap, workflowSummaries) => {
  return workflowSummaries.map(summary => {
    return {
      text: summary.name,
      value: summary.flowId,
      disabled: summary.enrollmentTrigger === 'EVENT' || !!formWorkflowDependenciesMap[summary.flowId],
      shouldEditManually: summary.enrollmentTrigger === 'EVENT'
    };
  });
});